





















import { store } from '@/utils/store';
import { Component, Vue } from 'vue-property-decorator';
import { zeroPadding } from '@/utils/utils';

@Component
export default class SelfStatus extends Vue {
  limitTime = 300;
  count = this.limitTime;
  timer!: number;
  clock!: number;

  get working() {
    return store.status === 'Working';
  }

  get getActiveTime() {
    const hour = zeroPadding(Math.floor(store.activeTime / 3600), 2);
    const min = zeroPadding(Math.floor((store.activeTime - (3600 * Number(hour))) / 60), 2);
    const second = zeroPadding(store.activeTime % 60, 2);
    return `${hour}:${min}:${second}`;
  }

  get remainingTime() {
    const min = zeroPadding(Math.floor(this.count / 60), 2);
    const second = zeroPadding(this.count % 60, 2);
    return `${min}:${second}`;
  }

  setStatus(status: Status) {
    const oldStatus = store.status; // ボタンを押される前の状態
    store.status = status;
    if (oldStatus === store.status) return;
    store.sendStatus(status);
    if (status === 'Breaking') {
      this.timer = setInterval(() => {
        this.count -= 1;
        if (this.count <= 0) this.setStatus('Working');
      }, 1000);
    } else {
      this.count = this.limitTime;
      clearInterval(this.timer);
    }
  }

  created() {
    if (store.stopping) {
      store.stopping = false;
      this.clock = setInterval(() => {
        if (store.status === 'Working') {
          store.incrementActiveTime();
        }
      }, 1000);
    }
  }

  beforeDestroy() {
    clearInterval(this.clock);
    store.stopping = true;
  }
}
